<template>
  <BannerForm update />
</template>
<script>
import appConfig from '@/app.config'
import BannerForm from '../../../components/skillup/banner/BannerForm.vue'
export default {
  page: {
    title: 'مدیریت بنر هدیه',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-gift-banner',
  components: {
    BannerForm,
  },
}
</script>
